/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CourtsInputs */

const th_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามแข่ง`)
};

const en_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Courts`)
};

const ja_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コート数`)
};

const zh_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球场`)
};

const es_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pistas`)
};

const pt_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadras`)
};

const id_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lapangan`)
};

const fr_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terrains`)
};

const tl_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga court`)
};

const vi_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sân`)
};

const ko_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코트`)
};

const de_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felder`)
};

const ru_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Площадки`)
};

const tr_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahalar`)
};

const it_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campi`)
};

const pl_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boiska`)
};

const uk_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майданчики`)
};

const hi_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोर्ट`)
};

const ar_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الملاعب`)
};

const ms_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelanggang`)
};

const bn_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোর্ট`)
};

const zh_tw2_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球場`)
};

const zh_hk2_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球場`)
};

const ur_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کورٹ`)
};

const fa_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زمین‌ها`)
};

const sw_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viwanja`)
};

const nl_courts = /** @type {(inputs: CourtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velden`)
};

/**
* | output |
* | --- |
* | "Courts" |
*
* @param {CourtsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const courts = /** @type {((inputs?: CourtsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CourtsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_courts(inputs)
	if (locale === "ja") return ja_courts(inputs)
	if (locale === "zh") return zh_courts(inputs)
	if (locale === "es") return es_courts(inputs)
	if (locale === "pt") return pt_courts(inputs)
	if (locale === "id") return id_courts(inputs)
	if (locale === "fr") return fr_courts(inputs)
	if (locale === "tl") return tl_courts(inputs)
	if (locale === "vi") return vi_courts(inputs)
	if (locale === "ko") return ko_courts(inputs)
	if (locale === "de") return de_courts(inputs)
	if (locale === "ru") return ru_courts(inputs)
	if (locale === "tr") return tr_courts(inputs)
	if (locale === "it") return it_courts(inputs)
	if (locale === "pl") return pl_courts(inputs)
	if (locale === "uk") return uk_courts(inputs)
	if (locale === "hi") return hi_courts(inputs)
	if (locale === "ar") return ar_courts(inputs)
	if (locale === "ms") return ms_courts(inputs)
	if (locale === "bn") return bn_courts(inputs)
	if (locale === "zh-TW") return zh_tw2_courts(inputs)
	if (locale === "zh-HK") return zh_hk2_courts(inputs)
	if (locale === "ur") return ur_courts(inputs)
	if (locale === "fa") return fa_courts(inputs)
	if (locale === "sw") return sw_courts(inputs)
	if (locale === "nl") return nl_courts(inputs)
	return en_courts(inputs)
});